/** RESPONSIBILITY: the leadership team grid. */
import { idOf } from '@framework/core';
import type { LeadershipTeamSection } from '@app/sections';
import { PersonCard } from '../commons/PersonCard';

export function LeadershipTeam({ c }: { c: LeadershipTeamSection }) {
  const team = c.team ?? [];
  if (team.length === 0) return null;

  return (
    <section className="band ldr-team-band">
      <div className="wrap">
        <div className="ldr-band-head ldr-band-head--centre">
          {c.eyebrow && <span className="ldr-kicker">{c.eyebrow}</span>}
          <h2 className="ldr-h2">{c.teamHeading}</h2>
          {c.teamIntro && <p className="lede">{c.teamIntro}</p>}
        </div>

        <div className="grid grid-4 ldr-team-grid">
          {team.map((p) => <PersonCard key={idOf(p)} p={p} />)}
        </div>
      </div>
    </section>
  );
}
